import React, { useCallback } from 'react';

import ThresholdColourInput from 'components/ThresholdColourInput';

import FieldSlideOutSection from './FieldSlideOutSection';

const BonusScoreColourSettings = ({
  fieldView,
  updateView,
}: {
  fieldView: FleetOps.BaseViewField;
  updateView: (newView: FleetOps.BaseViewField) => void;
}) => {
  const onChange = useCallback(
    (newConfig: FleetOps.BonusScoreColourConfig) => {
      updateView({ ...fieldView, bonusScoreColourConfig: newConfig });
    },
    [fieldView, updateView],
  );

  return (
    <FieldSlideOutSection>
      <ThresholdColourInput
        colourConfig={fieldView.bonusScoreColourConfig}
        onChange={onChange}
        isModeSelectable
      />
    </FieldSlideOutSection>
  );
};

export default BonusScoreColourSettings;
